import { VAuthCallback, VAuthCallbackError } from '@b2ag/auth/auth-views'
import '@b2ag/auth/style.css'
import { useAuthService } from '@b2ag/auth'
import { i18n } from '@b2ag/locale'
import { locationStorage } from '../../services'

import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'

/* ------- CONTEXTS - AUTHENTIFICATION ------- */

export const authRoutes = [
  {
    path: '/oauth/login',
    name: 'login',
    meta: {
      doNotStoreRoute: true,
      oauthWorkflow: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login()
      },
    },
  },
  {
    path: '/oauth/login/smag',
    name: 'smag-sso',
    meta: {
      oauthWorkflow: true,
      doNotStoreRoute: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SMAG_SSO,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login({ target: 'SMAG' })
      },
    },
  },
  {
    path: '/oauth/login/extranet',
    name: 'login-extranet',
    meta: {
      oauthWorkflow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: {
      template: '<div></div>',
      setup: () => {
        const authService = useAuthService()
        authService.login({ target: 'EXTRANET' })
      },
    },
    beforeEnter(to, _, next) {
      localStorage.setItem('extranetPartnerId', to.query.partner as string)
      localStorage.setItem('extranetMembershipNumber', to.query.membershipNumber as string)
      next()
    },
  },
  {
    path: '/oauth/callback',
    name: 'auth-callback',
    component: VAuthCallback,
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      oauthWorkflow: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.OAUTH_CALLBACK,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    props: () => {
      return {
        targetRoute: locationStorage.afterLoginPath,
        router: {
          push: (data) => Promise.resolve(window.location.replace(data)),
        },
        auth: useAuthService(),
        i18n,
      }
    },
    beforeEnter(to, _, next) {
      if (to.query.error_description) {
        next({ name: 'auth-callback-error', query: to.query })
      }
      next()
    },
  },
  {
    path: '/oauth/error',
    name: 'auth-callback-error',
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      private: false,
      oauthWorkflow: true,
      analyticsPageType: PAGE_TYPE.AUTH,
      layout: 'minimal',
    },
    component: VAuthCallbackError,
    props: (route) => {
      return {
        errorDetails: {
          clientId: route.query.client_id,
          connection: route.query.connection,
          lang: route.query.lang,
          errorCode: route.query.error_code || route.query.error,
          tracking: route.query.tracking,
          errorDescription: route.query.error_description,
        },
        auth: useAuthService(),
        appName: i18n._('Aladin'),
        i18n,
        captureMessage: () => {},
      }
    },
  },
]
